export default {
	namespaced: true,

	state: () => ({
		result: null,
		originalImageUrl: null,
		skipped: false,
	}),

	mutations: {
		SET_RESULT(state, result) {
			state.result = result
		},
		SET_ORIGINAL_IMAGE(state, url) {
			state.originalImageUrl = url
		},
		SET_SKIPPED(state, value) {
			state.skipped = value
		},
	},

	actions: {
		setResult({ commit }, result) {
			commit('SET_RESULT', result)
		},
		setOriginalImage({ commit }, url) {
			commit('SET_ORIGINAL_IMAGE', url)
		},
		setSkipped({ commit }, value) {
			commit('SET_SKIPPED', value)
		},
	},

	getters: {
		getResult: (state) => state.result,
		getOriginalImage: (state) => state.originalImageUrl,
		getSkipped: (state) => state.skipped,
	},
}
